import {
  Column,
  Copy,
  Flex,
  Heading,
  Row,
  Section,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { getConfig } from 'src/utilities/config';
import { LogoHeader } from 'src/components/selfService/features/Signup/pages/SignupInfoPage/LogoHeader/LogoHeader';
import { InfoSection } from 'src/components/selfService/features/Signup/pages/SignupInfoPage/InfoSection/InfoSection';
import { ContactOptions } from 'src/components/selfService/features/Signup/pages/SignupInfoPage/ContactOptions/ContactOptions';

export default function SignupInfoPage(): JSX.Element {
  const { isPhone } = useScreenSizes();
  const {
    site: { standardTitle: siteTitle },
  } = getConfig();

  return (
    <>
      <Helmet defer={false}>
        <title>{`${siteTitle} | Signup Info`}</title>
      </Helmet>
      {isPhone && <LogoHeader />}
      <Flex height="100vh">
        {!isPhone && (
          <Stack width="50%" height="100%" overflow="hidden">
            <Stack
              height="100%"
              width="100%"
              aria-label="grubhub corporate accounts image"
              style={{
                background: `
                      linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), 
                      url('https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750323304/corp-management-ui/b8o37ykn0k6hfgnnvezj.webp')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <LogoHeader />
              <Flex width="100%" height="100%" alignItems="center">
                <Square inset="lg">
                  <Stack y="lg">
                    <Heading variant="h1" color="globals.white">
                      Feed your team with Grubhub
                    </Heading>
                  </Stack>
                  <Row>
                    <Column phone={8}>
                      <Copy variant="lead" color="globals.white">
                        From catering to individual meal perks, feeding
                        in-person and remote employees has never been easier.
                      </Copy>
                    </Column>
                  </Row>
                </Square>
              </Flex>
            </Stack>
          </Stack>
        )}
        <Flex alignItems="center" justifyContent="center" flex="1">
          <Section inset="lg" maxWidth="600px">
            <InfoSection />
            <Stack y="lg">
              <ContactOptions />
            </Stack>
            <Copy variant="body" display="block" textAlign="center">
              Thanks for your interest in Grubhub Corporate!
            </Copy>
          </Section>
        </Flex>
      </Flex>
    </>
  );
}
